import { effect, Injectable, Injector } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs/operators';

@Injectable()
export class PreviousRouteService {
  private previousUrl: string;
  private currentUrl: string;
  history: string[] = [];
  private historyTrackingInitialized = false;
  private readonly navigationEnd = toSignal(
    this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)),
    { initialValue: null, injector: this.injector }
  );

  constructor(private readonly router: Router, private readonly injector: Injector) {
    this.currentUrl = this.router.url;
    effect(
      () => {
        const event = this.navigationEnd();
        if (!event) {
          return;
        }

        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      },
      { injector: this.injector }
    );
  }

  public loadRouting(): void {
    if (this.historyTrackingInitialized) {
      return;
    }

    this.historyTrackingInitialized = true;
    effect(
      () => {
        const event = this.navigationEnd();
        if (event) {
          this.history = [...this.history, event.urlAfterRedirects];
        }
      },
      { injector: this.injector }
    );
  }

  public getHistory(): string[] {
    return this.history;
  }

  public getPreviousUrl(): string {
    return this.history[this.history.length - 2] || this.previousUrl || '/index';
  }
}
